import TrouphySVG from "../../utils/TrouphySVG";
import React, { useState } from "react";
import { useArtistAwards } from "@/api/hooks/useArtistAwards";
import { useAwardsStore } from "@/stores/awardsStore";
import { X } from "lucide-react";
import { Loader } from "@/components/ui/Loader";
import MaskExactProfessionalName from "../../utils/MaskExactProfessionalName";

interface ArtistFreeAwardsProps {
  hideTitle?: boolean;
  enableDelete?: boolean;
}

const ArtistFreeAwards: React.FC<ArtistFreeAwardsProps> = ({
  hideTitle,
  enableDelete = false,
}) => {
  const { awards } = useArtistAwards();
  const deleteItem = useAwardsStore((s) => s.deleteItem);
  const [deletingId, setDeletingId] = useState<number | null>(null);

  const hasAnyRealAward = awards.some(
    (item) => !item.isPlaceholder && typeof item.id === "number",
  );

  if (!hasAnyRealAward) return null;

  return (
    <div className="my-20 md:my-28">
      {!hideTitle && (
        <h3 className="text-[28px] text-center md:text-[42px] font-bold bg-gradient-to-r from-[#F16B2E] via-[#EC2179] to-[#EC2179] text-transparent bg-clip-text">
          AWARDS & ACHIEVEMENTS
        </h3>
      )}
      <div>
        <div className="grid grid-cols-3 md:grid-cols-3 xl:grid-cols-4 w-full gap-5 my-8 place-items-center">
          {awards.map((item) => {
            const isRealAward = !item.isPlaceholder && typeof item.id === "number";
            const canDelete = enableDelete && isRealAward;
            const isDeleting = deletingId === item.id;

            const handleDelete = async () => {
              if (!canDelete || deletingId !== null) return;
              try {
                setDeletingId(item.id as number);
                await deleteItem(item.id as number);
              } finally {
                setDeletingId(null);
              }
            };

            return (
              <div
                key={item.id}
                className="flex flex-col items-center justify-start gap-2 w-full h-full rounded-xl aspect-square p-2"
              >
                <TrouphySVG />
                <div className="relative max-w-[180px] sm:max-w-[240px]">
                  {canDelete && (
                    <button
                      type="button"
                      onClick={handleDelete}
                      disabled={isDeleting}
                      className="absolute -top-16 -right-3 md:-top-24 z-50 flex h-6 w-6 items-center justify-center rounded-full bg-black/70 text-xs text-white border border-white/40 disabled:opacity-60"
                    >
                      {isDeleting ? <Loader size="small" /> : <X className="h-3 w-3" />}
                    </button>
                  )}
                  <p
                    className={`text-[12px] sm:text-[16px] text-center font-light max-w-24 ${item.isPlaceholder ? "opacity-80 italic" : ""}`}
                  >
                    <MaskExactProfessionalName value={item.displayText} />
                  </p>
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </div>
  );
};

export default ArtistFreeAwards;
